import React, { useState, useEffect, Fragment, useCallback } from 'react';
import classnames from 'classnames';

import iconDelete from '../../../assets/images/icon_delete_red.svg';
import iconAdd from '../../../assets/images/ic_plus_white.svg';
import iconBoxArrow from '../../../assets/images/icon_box_arrow_right.svg';

import SelectEscape from './SelectEscape';

import Condition from '../../../model/Condition';

function ConditionSetting({ condition, onChangeValue }) {
  const [conditionData, setConditionData] = useState({
    id: '',
    context: '',
    operator: '',
    value: '',
    destination: '',
    variable: '',
  });

  useEffect(() => {
    if (condition) {
      setConditionData(condition);
    }

    return () => setConditionData({});
  }, [condition]);

  const handleChangeValue = (event) => {
    const { value, name } = event.target;
    const updatedCondition = { ...conditionData, [name]: value };

    setConditionData(updatedCondition);
    onChangeValue(updatedCondition);
  };

  return (
    <div className="settings-conditional-settings">
      <img className="arrow" src={iconBoxArrow} alt="" />
      <div className="column">
        {Object.keys(Condition.CONTEXTS).map((key) => {
          const context = Condition.CONTEXTS[key];

          return (
            <Fragment key={context.flag}>
              <div
                className="section item"
                onClick={() =>
                  handleChangeValue({
                    target: { name: 'context', value: context.flag },
                  })
                }
              >
                <div
                  className={classnames({
                    active: conditionData.context === context.flag,
                  })}
                />
                <span>{context.description}</span>
              </div>
              {conditionData.context === context.flag && context.variable && (
                <div className="section item">
                  <input
                    value={conditionData.variable}
                    name="variable"
                    onChange={handleChangeValue}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
      </div>

      <div className="column bordered">
        {Object.keys(Condition.OPERATORS).map((key) => {
          const operator = Condition.OPERATORS[key];
          return (
            <div
              className="section item"
              key={`operator${key}`}
              onClick={() =>
                handleChangeValue({
                  target: { name: 'operator', value: operator.flag },
                })
              }
            >
              <div
                className={classnames({
                  active: conditionData.operator === operator.flag,
                })}
              />
              <span>{operator.description}</span>
            </div>
          );
        })}
      </div>

      <div className="column bordered">
        <div className="section item">
          <span>Valor</span>
        </div>
        <div className="section item">
          <input
            name="value"
            value={conditionData.value}
            onChange={handleChangeValue}
          />
        </div>
        <div className="section values" />

        <SelectEscape
          onSelect={(value) =>
            handleChangeValue({ target: { name: 'destination', value } })
          }
          label="Destino"
          destinationId={conditionData.destination}
        />
      </div>
    </div>
  );
}

export default function ({ item, doUpdateItem }) {
  const [itemData, setItemData] = useState({ conditions: [] });
  const [editingCondition, setEditingCondition] = useState(null);

  useEffect(() => {
    if (item) {
      setItemData(item);
    }
  }, [item]);

  const handleAddCondition = () => {
    const newCondition = new Condition();
    const { conditions } = itemData;

    const updatedItem = {
      ...itemData,
      conditions: [...conditions, newCondition],
    };
    setItemData(updatedItem);
    setEditingCondition(newCondition);
    doUpdateItem(updatedItem);
  };

  const handleRemoveCondition = (id) => {
    const updatedConditions = itemData.conditions.filter(
      (condition) => condition.id !== id
    );

    const updatedItem = {
      ...itemData,
      conditions: updatedConditions,
    };
    setItemData(updatedItem);
    doUpdateItem(updatedItem);
  };

  const handleUpdateConditionSetting = (updatedCondition) => {
    const updatedConditions = itemData.conditions.map((condition) =>
      condition.id === updatedCondition.id ? updatedCondition : condition
    );

    const updatedItem = {
      ...itemData,
      conditions: updatedConditions,
    };
    setItemData(updatedItem);
    doUpdateItem(updatedItem);
  };

  const getConditionDescription = useCallback((condition) => {
    if (!condition) return null;
    return `${Condition.CONTEXTS[condition.context].description} ${
      Condition.OPERATORS[condition.operator].description
    }`;
  }, []);

  return (
    <>
      <p className="handler-title">Condicional</p>

      <div className="form-group validation-input-group mb-1">
        <label>Condições adicionais</label>
      </div>

      {itemData?.conditions?.length === 0 && (
        <div className="form-group">
          <button
            className="settings-conditional-button-create-condition"
            onClick={() => handleAddCondition()}
            type="button"
          >
            Criar nova condição
          </button>
        </div>
      )}

      {!!itemData.conditions.length &&
        itemData.conditions.map((condition) => (
          <div
            className="settings-conditional-condition mt-2 mb-2"
            key={condition.id}
          >
            <span onClick={() => setEditingCondition(condition)}>
              Se{' '}
              <strong>
                <u>{getConditionDescription(condition)}</u>
              </strong>
            </span>
            <img
              src={iconDelete}
              onClick={() => handleRemoveCondition(condition.id)}
              alt=""
            />
          </div>
        ))}

      {!!editingCondition && (
        <ConditionSetting
          condition={editingCondition}
          onChangeValue={handleUpdateConditionSetting}
        />
      )}

      {!!itemData.conditions.length && (
        <div className="settings-conditional-plus">
          <button onClick={() => handleAddCondition()} type="button">
            <img src={iconAdd} alt="" />
          </button>
        </div>
      )}
    </>
  );
}
